import WebsocketConnection from "@/api/ws/WebsocketConnection";
import type { BaseEvent } from "@/api/ws/events/BaseEvent";

export abstract class BaseChannel {
  abstract name: string;
  isPrivate = false;

  constructor(protected id?: string | number) {}

  /**
   * The full channel name composed of the base name and the id if provided.
   */
  private get fullName(): string {
    return this.id ? `${this.name}.${this.id}` : this.name;
  }

  private get channelMethod() {
    return this.isPrivate ? "private" : "channel";
  }

  /**
   * Subscribe to the given events
   * @returns void
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  subscribeTo<Events extends BaseEvent<any>[]>(...events: Events) {
    events.forEach((event) => {
      WebsocketConnection.instance[this.channelMethod](this.fullName).listen(
        event.name,
        event.callback
      );
    });
  }

  /**
   * Unsubscribe from the given events
   * @returns void
   */
  unsubscribeFrom<CallbackData extends Record<string, unknown>>(
    ...events: BaseEvent<CallbackData>[]
  ) {
    events.forEach((event) => {
      WebsocketConnection.instance[this.channelMethod](this.fullName).stopListening(event.name);
    });
  }

  /**
   * Leave the current channel.
   * @returns void
   */
  leave() {
    if (!WebsocketConnection.isConnected) {
      return;
    }
    WebsocketConnection.instance.leave(this.fullName);
  }
}
